var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-dialog', {
    attrs: {
      "width": "680",
      "persistent": ""
    },
    model: {
      value: _vm.dialog,
      callback: function ($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "ma-4 mx-6"
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_vm.content ? _c('v-card-text', {
    staticClass: "pa-0 mt-2"
  }, [_vm._v(" " + _vm._s(_vm.content) + " ")]) : _vm._e()], 1), _c('div', {
    staticClass: "mb-4"
  }, [_vm.confirmationMessage ? _c('v-card-text', {
    staticClass: "pa-0 mt-2"
  }, [_vm._v(" " + _vm._s(_vm.confirmationMessage) + " ")]) : _vm._e()], 1)]), _c('v-card-actions', {
    staticClass: "pa-4 px-8 pb-6"
  }, [_c('v-spacer'), _c('v-btn', {
    staticClass: "text-uppercase mr-4",
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('cancel')) + " ")]), _c('v-btn', {
    staticClass: "text-uppercase",
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('confirm')) + " ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }